import { observer } from "mobx-react";
import React from "react";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";

import MessagePanel from "./MessagePanel";

interface InboxTabContentProps {}

const InboxTabContent: React.FC<InboxTabContentProps> = withWSErrorContainer(
  observer(({}) => {
    return (
      <>
        {inboxData.map((data) => {
          const { id, date, name } = data;
          return (
            <MessagePanel
              key={id}
              date={date}
              name={name}
              fromTo="Fra:"
              id={id}
            />
          );
        })}
      </>
    );
  })
);
export default InboxTabContent;

// export const StyledTabContent = styled.div`
//   &.cvp-tab-content {
//     display: flex;
//     flex-direction: column;
//     row-gap: 0.63rem;
//   }
// `;

export const inboxData = [
  {
    id: "1",
    date: "21.11.2022",
    name: "Bemanningsentralen",
  },
  {
    id: "2",
    date: "21.11.2022",
    name: "Bemanningsentralen",
  },
  {
    id: "3",
    date: "21.11.2022",
    name: "Bemanningsentralen",
  },
  {
    id: "4",
    date: "21.11.2022",
    name: "Bemanningsentralen",
  },

  {
    id: "5",
    date: "20.11.2022",
    name: "Bemanningsentralen",
  },

  {
    id: "6",
    date: "19.11.2022",
    name: "Bemanningsentralen",
  },
  {
    id: "7",
    date: "18.11.2022",
    name: "Bemanningsentralen",
  },
  {
    id: "8",
    date: "17.11.2022",
    name: "Bemanningsentralen",
  },
];
